import React from "react"
import styled from "@emotion/styled"
import { color, breakpoints } from "../../utils/style"
import ButtonLink from "../shared/ButtonLink"
import Facebook from "../../icons/svg/FacebookPlain"
import Youtube from "../../icons/svg/YoutubePlain"
import PhoneBackground from "../../icons/svg/PhoneBackground"
import IcomoonIcon from "../shared/IcomoonIcon"
import Hamburger from "../../icons/svg/Hamburger"

const HeaderContacts = styled("div")`
  flex-basis: 51%;
  text-align: right;
  padding-top: 7px;
  .header-search-wrapper {
    display: inline-block;
  }
  .header-contact-group {
    display: inline-block;
    vertical-align: top;
    .button {
      padding: 6px 8px;
      margin: 0 25px;
      font-size: 1.1rem;
      text-align: left;
      display: inline-block;
      vertical-align: middle;
    }
    .green-button {
      margin: 0 32px 0 0;
      span {
        font-size: 15px;
        font-weight: 400;
        display: inline-block;
        vertical-align: baseline;
      }
    }
  }
  .call-button {
    margin: 0 32px 0 0;
    color: ${color.white};
    text-decoration: none;
  }
  .facebook-link {
    margin: 0 32px 0 0;
  }
  .facebook-link,
  .youtube-link {
    vertical-align: middle;
    svg {
      path {
        transition: 0.15s all linear;
      }
    }
    &:hover svg path {
      fill: ${color.pink};
    }
  }
  
  .header-image-wrap,
  .button {
    display: inline-block;
    vertical-align: top;
    margin-bottom: 20px;
  }
  .header-image-wrap .gatsby-image-wrapper {
    border-radius: 100%;
  }
  .popup-content {
    text-align: center;
  }
  .header-contact-group-mobile {
    display: none;
    height: 100%;
    padding: 0 15px;
    .button {
      vertical-align: middle;
      width: 40px;
      height: 40px;
      padding: 9px 8px;
      border-radius: 50%;
      border: none;
      background: ${color.pink};
      margin-right: 16px;
      &:last-child {
        margin-right: 0;
      }
    }
  }

  @media (max-width: ${breakpoints.lg}) {
    flex-basis: 63%;
  }

  @media (max-width: ${breakpoints.md}) {
    // display: none;
    flex-basis: 50%;
    height: 100%;
    .header-contact-group {
      display: none;
    }
    .header-search-wrapper {
      display: block;
      width: 100%;
      position: relative;
      .close-menu {
        position: absolute;
        top: 22px;
        right: 5px;
        background: none;
      }
    }
    .header-contact-group-mobile {
      display: block;
    }
  }
`

const El = styled('button')`
   svg:nth-of-type(2) {
     display: none !important;
   }
   &.clicked {
     svg:nth-of-type(1) {
       display: none !important;
     }
     svg:nth-of-type(2) {
       display: inline-block !important;
       path {fill: ${color.white} !important;}
       filter: drop-shadow(1px 1px 6px ${color.peach});
     }
   }
`;

export default ({ children }) => {

  const handleClick = (e) => {
    e.preventDefault();
    const ul = document.getElementById('nav');
    const layout = document.getElementById('all-content');
    layout.classList.toggle('bg-added');
    ul.classList.toggle('open');
    const target = document.getElementById('mobile-menu-open');
    target.classList.toggle('clicked');
  };

  return (
    <HeaderContacts id="header-contacts-menu" className="header-contacts-menu">
      {children}
      <div className="header-contact-group">
        <ButtonLink
          to={process.env.LINE_ID_EXT}
          text={process.env.LINE_ID_TEXT}
          external={true}
          className="button green-button"
          iconName="line"
          iconSize={20}
          ariaText="Line"
          iconLeft={true}
        />

        <ButtonLink
          to={`tel:${process.env.PHONE_TO_CALL}`}
          external={true}
          ariaText="Call"
          className="call-button"
          text={process.env.PHONE_TO_DISPLAY}
          iconName="call-answer"
          iconLeft={true}
          iconColor={color.white}
          iconSize={16}
        />

        <a
          href={process.env.FACEBOOK_LINK}
          rel="noreferrer"
          title="SCR888-VIP Facebook"
          target="_blank"
          className="facebook-link"
        >
          <Facebook />
        </a>
        <a
          href={process.env.YOUTUBE_LINK}
          rel="noreferrer"
          title="SCR888-VIP Youtube"
          target="_blank"
          className="youtube-link"
        >
          <Youtube />
        </a>
      </div>
      <div className="header-contact-group-mobile">
        <a className="button" href={`tel:${process.env.PHONE_TO_CALL}`}>
          <PhoneBackground/>
        </a>
        <ButtonLink
          to={process.env.LINE_ID_EXT}
          text={''}
          external={true}
          className="button"
          iconName="line"
          iconSize={22}
          ariaText="Line"
          iconLeft={true}
          iconColor={color.white}
        />
        <El className="button" id="mobile-menu-open" aria-label="Menu" onClick={(e) => handleClick(e)}>
          <Hamburger/>
          <IcomoonIcon className="mobile-menu-close-icon" icon="close-menu" color={color.white} size={20} />
        </El>
      </div>
    </HeaderContacts>
  )
}
